module.exports = __webpack_public_path__ + "static/img/medal.47dc6c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medal.svg
// module id = uH6B
// module chunks = 1